import { Directive, ElementRef, Input} from "@angular/core";

@Directive({
    selector : '[changeFocus]'
})
export class ChangeFocusDirective {
    constructor(public elementRef: ElementRef) {}

    @Input()
    set changeFocus(value: boolean) {
        if(value) {
            this.elementRef.nativeElement.focus();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/change-focus.directive.ts